import React from 'react';
import { DownloadIcon, RefreshCwIcon } from 'lucide-react';
import { Officer, Period, Role } from '../types/commission';
import { PeriodPicker } from './PeriodPicker';
interface DashboardHeaderProps {
  officer: Officer;
  role: Role;
  periods: Period[];
  selectedPeriodId: string;
  onSelectPeriod: (periodId: string) => void;
  showRecalculate: boolean;
  recalculateSaving: boolean;
  onRecalculate: () => void;
  showExport: boolean;
  onExport: () => void;
  isExporting: boolean;
}
export function DashboardHeader({
  officer,
  role,
  periods,
  selectedPeriodId,
  onSelectPeriod,
  showRecalculate,
  recalculateSaving,
  onRecalculate,
  showExport,
  onExport,
  isExporting
}: DashboardHeaderProps) {
  const selectedPeriod = periods.find(period => period.id === selectedPeriodId) ?? periods[0];
  return <header className="border-b border-slate-200 bg-white" data-id="element-233" data-mp="15izejzqcja22">
      <div className="mx-auto flex max-w-7xl flex-col gap-5 px-6 py-5 lg:flex-row lg:items-center lg:justify-between" data-id="element-234" data-mp="1ag7vjwzrd81q">
        <div className="flex items-center gap-4" data-id="element-235" data-mp="3nw0nf2gbkrxb">
          <div aria-hidden="true" className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-900 text-sm font-bold tracking-wide text-white" data-id="element-236" data-mp="3nsmm7xje6org">
            {officer.initials}
          </div>
          <div data-id="element-237" data-mp="39w82jnrh55x9">
            <p className="text-xs font-semibold uppercase tracking-widest text-brand-700" data-id="element-238" data-mp="39wr8e63uo3ux">Loan Commissions</p>
            <h1 className="text-xl font-bold text-slate-900" data-id="element-239" data-mp="bcrbtvpkho5o">{officer.name}</h1>
            <p className="mt-0.5 text-sm text-slate-500" data-id="element-240" data-mp="6fskfkxafvb6">
              {role.name} · {officer.branch} · {officer.nmls}
            </p>
          </div>
        </div>

        {isExporting ? <div className="text-left lg:text-right" data-id="element-241" data-mp="3st0wzncdoct6">
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400" data-id="element-242" data-mp="u420s7bqfqux">Commission statement</p>
            <p className="mt-1 text-lg font-bold text-slate-900" data-id="element-243" data-mp="pdllsis9jx6g">
              {role.name} · {selectedPeriod.label}
            </p>
          </div> : <div className="flex flex-wrap items-center gap-3 lg:justify-end" data-id="element-244" data-mp="2jlz5qxr4g5h1">
            <PeriodPicker periods={periods} selectedPeriodId={selectedPeriodId} onSelect={onSelectPeriod} data-id="element-245" data-mp="2nlhjn9kizgad" />

            {showRecalculate ? <button type="button" onClick={onRecalculate} disabled={recalculateSaving} className="inline-flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60" data-id="element-246" data-mp="2euh8ajob4n0t">
                <RefreshCwIcon className={`h-4 w-4 ${recalculateSaving ? 'animate-spin' : ''}`} aria-hidden="true" data-id="element-247" data-mp="1qyl9z2z5tfyi" />
                {recalculateSaving ? 'Recalculating…' : 'Recalculate pay period'}
              </button> : null}

            {showExport ? <button type="button" onClick={onExport} className="inline-flex items-center gap-2 rounded-lg bg-brand-700 px-3.5 py-2 text-sm font-semibold text-white transition hover:bg-brand-800" data-id="element-248" data-mp="3q8b5njfch5r7">
                <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-249" data-mp="d10fgyj2r5ap" />
                Export statement
              </button> : null}
          </div>}
      </div>
    </header>;
}